import React, { FC } from 'react';

type PropsT = {
  fill?: string;
};

const PresentationLeftArrowIcon: FC<PropsT> = ({ fill = 'white' }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M9.41058 11.9996L16.532 5.11139C16.8896 4.76554 16.8896 4.20483 16.532 3.85899C16.1745 3.51315 15.5948 3.51315 15.2372 3.85899L7.46836 11.3734C7.11081 11.7193 7.11081 12.28 7.46836 12.6258L15.2372 20.1402C15.5948 20.4861 16.1745 20.4861 16.532 20.1402C16.8896 19.7944 16.8896 19.2337 16.532 18.8878L9.41058 11.9996Z"
      fill={fill}
    />
  </svg>
);

export default PresentationLeftArrowIcon;
import React, { FC } from 'react';

type PropsT = {
  fill?: string;
};

const PresentationLeftArrowIcon: FC<PropsT> = ({ fill = 'white' }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M9.41058 11.9996L16.532 5.11139C16.8896 4.76554 16.8896 4.20483 16.532 3.85899C16.1745 3.51315 15.5948 3.51315 15.2372 3.85899L7.46836 11.3734C7.11081 11.7193 7.11081 12.28 7.46836 12.6258L15.2372 20.1402C15.5948 20.4861 16.1745 20.4861 16.532 20.1402C16.8896 19.7944 16.8896 19.2337 16.532 18.8878L9.41058 11.9996Z"
      fill={fill}
    />
  </svg>
);

export default PresentationLeftArrowIcon;
